import api from '../utils/api';

export async function loginUser(username, password) {
  const response = await api.post('/login', { username, password });
  const { token, user } = response.data.data;
  localStorage.setItem('auth_token', token);
  localStorage.setItem('user_data', JSON.stringify(user));
  return user;
}

export function logoutUser() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_data');
}

export function getCurrentUser() {
  const data = localStorage.getItem('user_data');
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!localStorage.getItem('auth_token');
}
